import GameModel from 'src/game/GameModel';
import {Loc} from 'src/common/map/Location';
import * as PIXI from 'pixi.js';
import GameConfig from './GameConfig';

function distance(a: Loc, b: Loc): number {
    return Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);
}

function clamp(a: number, min: number, max: number): number {
    return Math.min(Math.max(a, min), max);
}

function locMix(a: Loc, b: Loc, f: number): Loc {
    return {
        x: a.x + (b.x - a.x) * f,
        y: a.y + (b.y - a.y) * f,
    };
}

// In tiles/second
const speed = 99;

export default class TargetCursor {
    private _sprite: PIXI.Text;
    private target: Loc;

    public constructor() {
        this.createSprite();
    }

    public get sprite(): PIXI.Text {
        return this._sprite;
    }

    public start(loc: Loc): void {
        this.show();
        this.target = {x: loc.x, y: loc.y};
        this.sprite.position.set(this.target.x, this.target.y);
    }

    public isVisible(): boolean {
        return !!this.sprite.parent;
    }

    public setTarget(loc: Loc): void {
        this.target = {x: loc.x, y: loc.y};
    }

    public tick(dt: number): void {
        this.moveTowards(this.target, dt);
    }

    public finish(): void {
        this.hide();
    }

    private createSprite(): void {
        const text = '◎';
        const style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32,
            fill: 0xffffff,
        });
        this._sprite = new PIXI.Text(text, style);
        this.sprite.anchor.set(0.5, 0.5);
    }

    private show(): void {
        GameModel.cursorContainer.addChild(this.sprite);
    }

    private hide(): void {
        GameModel.cursorContainer.removeChild(this.sprite);
    }

    private moveTowards(target: Loc, dt: number): void {
        const maxDist = speed * GameConfig.tileSize * (dt / 1000);
        const dist = distance(this.sprite.position, target);
        if (dist < 0.001) return;

        const toMove = clamp(dist, 0, maxDist);
        const newLoc = locMix(this.sprite.position, target, toMove / dist);
        this.sprite.position.set(newLoc.x, newLoc.y);
    }
}



// WEBPACK FOOTER //
// ./src/game/TargetCursor.ts